<template>
  <div id="page-autocomplete-demo">
    <!-- AJAX BASED AUTOCOMPLETE -->
    <vue-simple-suggest
      pattern="\w+"
      v-model="model"
      :list="getList"
      :max-suggestions="5"
      :min-length="1"
      :debounce="500"
      :filter-by-query="false"
      :prevent-submit="true"
      :controls="{
        selectionUp: [38, 33],
        selectionDown: [40, 34],
        select: [13, 36],
        hideList: [27]
      }"
      :mode="mode"
      ref="suggestComponent"
      placeholder="Search company name or actual account name"
      value-attribute="id"
      display-attribute="name"
      @select="onSuggestSelect"
      :selectedSlave="selectedSlave"
      :campaignId="campaignId"
    >
    <!-- <template v-if="combined_matches.length > 0">
         <template v-for="(accepted,index) in combined_matches">
              <div v-if="accepted.slave_id == selectedSlave" :key="index" class="mb-5">
                    <h6>Accepted : </h6><p>{{ accepted.company_name}}</p>
              </div>
         </template>

    </template> -->
      <div class="g">
        <input
          type="text"
          placeholder="Search company name or actual account name."
        />
      </div>

      <template slot="misc-item-above" slot-scope="{ suggestions, query }">
        <div class="misc-item">
          <span>You're searching for '{{ query }}'.</span>
        </div>

        <template v-if="suggestions.length > 0">
          <!-- <div class="misc-item">
              <span>{{ suggestions.length }} suggestions are shown...</span>
            </div> -->
          <hr />
        </template>

        <div class="misc-item" v-else-if="!loading">
          <span>No results</span>
        </div>
      </template>

      <div
        slot="suggestion-item"
        slot-scope="scope"
        :title="scope.suggestion.name"
      >
        <div class="flex mb-4">
          <!-- <div class="w-1/6 bg-grid-color h-12">
            <vs-checkbox
              class="select-checkbox"
              v-model="selectCheckbox"
              :vs-value="scope.suggestion.id"
              v-on:change="onSuggestSelect(scope.suggestion)"
            ></vs-checkbox>
          </div> -->
          <div class="w-5/6 bg-grid-color-secondary h-12">
            <div class="text">
              <span v-html="boldenSuggestion(scope)"></span>
            </div>
          </div>
        </div>
      </div>

      <div
        class="misc-item"
        slot="misc-item-below"
        slot-scope="{ suggestions }"
        v-if="loading"
      >
        <span>Loading...</span>
      </div>
    </vue-simple-suggest>

    <!-- /AJAX BASED AUTOCOMPLETE -->
    <template v-if="selected">
      <vs-popup
        :title="accountDescription.company_name"
        :active.sync="popupActive"
        fullscreen
      >
        <div class="vx-row">
          <div class="flex justify-between flex-wrap fixedButtons">
            <vs-button
              class="mb-4 mr-6"
              @click="
                acceptMatch(accountDescription.id, unmatched_account.id,accountDescription.company_name)
              "
              type="border"
              >Accept</vs-button
            >
                
                <!-- <template v-if="combined_matches.length > 0">
         <template v-for="(accepted,index) in combined_matches">
              <template v-if="accepted.slave_id == selectedSlave" class="mb-5">
                  <vs-button :key="index"
              class="mb-4"
              type="border"
              @click="
                rejectMatch(accountDescription.id, unmatched_account.id , accountDescription.company_name)
              "
              color="primary"
              >Reject</vs-button
            >
                          </template>
         </template>

    </template> -->
            
          </div>
          <div class="flex mb-4">
            <div class="w-1/2 bg-grid-color-secondary h-12">
              <div class="detailPopUp">
                <vs-list style="height: 245px;">
                  <h3><u>Database Record</u></h3>
                  <vs-list-header
                    title="Key Company Details"
                    color="danger"
                  ></vs-list-header>
                  <vs-list-item title="Company Name ">
                    {{ accountDescription.company_name }}
                  </vs-list-item>

                  <vs-list-item title="Switchboard">
                    <template v-for="(ph, index) in accountDescription.phone">
                      <div :key="index">
                        <template v-for="(ph_type, index2) in ph.phone_type">
                          <div
                            :key="index2"
                            v-if="
                              ph_type.type ==
                                'head_office_switchboard' &&
                                ph_type.phone_id == ph.id
                            "
                          >
                          {{ ph.phone_code }}{{ ph.phone_no }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </vs-list-item>
                  <vs-list-item title="Site Switchboard">
                    <template v-for="(ph, index) in accountDescription.phone">
                      <div :key="index">
                        <template v-for="(ph_type, index2) in ph.phone_type">
                          <div
                            :key="index2"
                            v-if="
                              ph_type.type ==
                                'site_switchboard' &&
                                ph_type.phone_id == ph.id
                            "
                          >
                            {{ ph.phone_no }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </vs-list-item>
                  <vs-list-item title="Company Registration Number">
                    {{ accountDescription.company_registration_number }}
                  </vs-list-item>
                </vs-list>

                <vs-list style="height: 310px;">
                  <vs-list-header
                    title="Address"
                    color="danger"
                  ></vs-list-header>
                  <vs-list-item title="Head Office Address">
                    {{ accountDescription.head_office_address_1 }}
                    {{ accountDescription.head_office_address_2 }}
                    {{ accountDescription.head_office_address_3 }}
                    {{ accountDescription.head_office_city }}
                    {{ accountDescription.head_office_postcode }}
                    {{ accountDescription.head_office_county }}
                    {{ accountDescription.head_office_country }}
                  </vs-list-item>
                  <vs-list-item title="Registered Office Address">
                    {{ accountDescription.registered_office_address_1 }}
                    {{ accountDescription.registered_office_address_2 }}
                    {{ accountDescription.registered_office_address_3 }}
                    {{ accountDescription.registered_office_city }}
                    {{ accountDescription.registered_office_postcode }}
                    {{ accountDescription.registered_office_county }}
                    {{ accountDescription.registered_office_country }}
                  </vs-list-item>
                  <template
                    v-for="(satellite,
                    index) in accountDescription.satellite_office"
                  >
                    <vs-list-item
                      :title="'Satellite Office ' + (index + 1)"
                      :key="index"
                    >
                      <template v-for="(phone, index3) in satellite.phone">
                        <div
                          :key="index3"
                          v-if="phone.satellite_office_id == satellite.id"
                        >
                          {{ phone.phone_no }}
                        </div>
                      </template>
                      {{ satellite.address_1 }}
                      {{ satellite.address_2 }}
                      {{ satellite.address_3 }}
                      {{ satellite.town }}
                      {{ satellite.county }}
                      {{ satellite.postcode }}
                    </vs-list-item>
                  </template>
                </vs-list>

                <vs-list style="height: 200px; margin-top: 65px;">
                  <vs-list-header
                    title="Websites"
                    color="danger"
                  ></vs-list-header>
                  <template v-for="(web, index) in accountDescription.web">
                    <div :key="index">
                      {{ web.url }}
                    </div>
                  </template>
                </vs-list>
                <vs-list style="height: 200px; margin-top: 65px;">
                  <vs-list-header
                    title="LinkedIn"
                    color="danger"
                  ></vs-list-header>
                  <template
                    v-for="(linkedin, index) in accountDescription.linkedin"
                  >
                    <div :key="index">
                      {{ linkedin.url }}
                    </div>
                  </template>
                  <div v-if="accountDescription.registered_office">
                    <template
                      v-for="(registered_url,
                      index) in accountDescription.registered_office"
                    >
                      <div :key="index">
                        <template
                          v-for="(reg, index1) in registered_url.linkedin"
                        >
                          <div :key="index1">
                            {{ reg.url }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div v-if="accountDescription.satellite_office">
                    <template
                      v-for="(satellite_url,
                      index) in accountDescription.satellite_office"
                    >
                      <div :key="index">
                        <template
                          v-for="(sat, index1) in satellite_url.linkedin"
                        >
                          <div :key="index1">
                            {{ sat.url }}
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                </vs-list>
              </div>
            </div>
            <div class="w-1/2 bg-grid-color h-12">
              <div class="detailPopUp" v-if="accountDescription.slave">
                <vs-list style="height: 245px;">
                  <h3><u>Import Record</u></h3>
                  <vs-list-header
                    title="Key Company Details"
                    color="danger"
                  ></vs-list-header>

                  
                  <vs-list-item title="Company Name ">
                    {{ accountDescription.slave.ml_company }}
                  </vs-list-item>
                  <!-- <vs-list-item title="Actual Account Name">
                    {{ accountDescription.slave.ml_actual_account_name }}
                  </vs-list-item> -->
                  <vs-list-item title="Switchboard">
                    {{ accountDescription.slave.ml_switchboard }}
                  </vs-list-item>
                  <vs-list-item title="Site Switchboard">
                    {{ accountDescription.slave.ml_site_switchboard }}
                  </vs-list-item>
                  <vs-list-item title="Phone">
                    {{ accountDescription.slave.ml_phone }}
                  </vs-list-item>
                </vs-list>
                <vs-list style="height: 310px;">
                  <vs-list-header
                    title="Address"
                    color="danger"
                  ></vs-list-header>
                  <div>
                    {{ accountDescription.slave.ml_addresses }}
                  </div>
                </vs-list>
                <vs-list style="height: 200px; margin-top: 65px;">
                  <vs-list-header
                    title="Website"
                    color="danger"
                  ></vs-list-header>
                  <div>
                    {{ accountDescription.slave.ml_web }}
                  </div>
                </vs-list>
                <vs-list style="height: 200px; margin-top: 65px;">
                  <vs-list-header
                    title="Linkedin"
                    color="danger"
                  ></vs-list-header>
                  <div>
                    {{ accountDescription.slave.ml_linkedin }}
                  </div>
                </vs-list>
              </div>
            </div>
          </div>
        </div>
      </vs-popup>
    </template>
  </div>
</template>

<script>
import { boldenMatches } from "@/util/escapeHtml";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";

import Prism from "vue-prism-component";
import axios from "@/axios.js";

export default {
  name: "Autocomplete",
  props: {
    unmatched_account: Object,
    selectedSlave: Number,
    campaignId:String,
    combined_matches: Array
  },
  data() {
    return {
      chosen: null,
      selected: null,
      model: null,
      mode: "input",
      loading: false,
      log: [],
      selectCheckbox: [],
      search_result: [],
      popupActive: false,
      accountDescription: [],
      accepted_ids: [],
      selection: []
    };
  },
  methods: {
    acceptMatch(master_id, slave_id,company_name) {
      if (this.selection.length > 0) {
        this.selection.map(element => {
          if (element.slave_id == slave_id) {
            element.master_id = master_id.toString()
            element.company_name = company_name
            return element
          } else {
            this.selection.push({
              master_id: master_id.toString(),
              slave_id: slave_id,
              company_name:company_name
            });
          }
        });
      } else {
        this.selection.push({
          master_id: master_id.toString(),
          slave_id: slave_id,
          company_name:company_name
        });
      }

      this.$emit("update-accepted-id", this.selection);
      this.popupActive = false;
      // this.chosen = this.accountDescription.company_name;
      
      // console.log("sdfsdfsdf" , this.chosen)

      // this.$refs.suggestComponent.input.value = this.chosen;
    },
    rejectMatch(master_id, slave_id,company_name) {
      this.selection.filter(ele => ele.slave_id != slave_id)
      // this.selection.pop({
      //   master_id: master_id.toString(),
      //   slave_id: slave_id,
      //   company_name : company_name
      // });
      // console.log(this.selection)
      this.chosen = null;
      this.$emit("update-rejected-id", this.selection);
      this.$refs.suggestComponent.input.value = "";
      this.popupActive = false;
    },
    onSuggestSelect(suggest) {

      this.selected = suggest;
      let master_slave_id = {};
      master_slave_id.master_id = suggest.id;
      master_slave_id.slave_id = this.selectedSlave;
      master_slave_id.campaignId = this.campaignId
      axios
        .post(
          this.$base_url + "/api/accounts/data_build_master_slave_accounts",
          master_slave_id
        )
        .then(response => {
          this.accountDescription = response.data;


           console.log("accountDescription", this.accountDescription);

          this.popupActive = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      // Release 2 (F2): the name is escaped before the matches are bolded, so a record name
      // can no longer run as HTML, and brackets typed in the search no longer break it.
      return boldenMatches(this.$refs.suggestComponent.displayProperty(suggestion), query);
    },
    getList(inputValue) {
      return axios
        .get(this.$base_url + "/api/accounts/search/" + inputValue)
        .then(response => {
          let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].uuid,
              name: data[property].company_name
            });
          }
          return mappedArray;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {},
  components: {
    VueSimpleSuggest,
    Prism,
    axios
  }
};
</script>

<style scoped>
.con-vs-popup .vs-popup {
  width: 900px;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/autocomplete.scss";
// .vs-checkbox--input{
//   position: relative;
// }

.fixedButtons {
  position: fixed;
  background: white;
  z-index: 1;
  width: 100%;
  justify-content: center !important;
}

.keyText {
  font-weight: 600;
}

.vuesax-app-is-ltr .vs-list--slot {
  margin-left: auto;
  width: 500px;
}

.vue-simple-suggest.designed .suggestions .suggest-item.selected {
  background-color: white !important;
}

.vue-simple-suggest.designed,
.vue-simple-suggest.designed * {
  color: black;
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
  background-color: #f5f5f5 !important;
}



.detailPopUp {
  width: 100%;
  margin: 10px;
  padding-left: 40px;
  padding-top: 45px;
}

.detailPopUp .vs-list--item {
  padding: 10px;
}

.con-vs-popup .vs-popup--content {
  height: 100%;
}
</style>
